import React from "react";

import useRemainingTimeForBank from "@/utilities/hooks/useRemainingTimeForBank";

const LiveTimerText = ({ actionedAt, publisheddAt }) => {
  const remainingTime = useRemainingTimeForBank(actionedAt, publisheddAt);

  return remainingTime === "Expired" ? (
    <p>Published to AppLocum Candidates</p>
  ) : (
    <p className="text-[14px] font-medium leading-[normal] text-black">
      Publish to AppLocum Candidates <br /> in{" "}
      <span className="font-bold">{remainingTime} </span>
    </p>
  );
};

export default LiveTimerText;
